import { Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import frontarrowIcon from "../../../assets/images/forwardArrow.svg";
import "./testmodule.scss";
import { getTestModule } from "../../../services/websiteApi";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import {
  GAIT_AND_BALANCE_INFO,
  LOCOMOTIVE_INFO,
  ROM_DETAILS,
  TUG_FRONT_INFO,
  TUG_SIDE_INFO,
} from "../../../routes/routerPath";
import { getParams, searchParams } from "../../../utlis/helpers";
import { useNavigate } from "react-router-dom";
import {
  dateFormatHanlder,
  userInfoFetch,
} from "../../../utlis/commonFunction";
import lockedIcon from "../../../assets/images/locked.svg";
import UserDetailsHeader from "../UserDetailsHeader";
import { pageLocale } from "../../../utlis/locale";

const TestModule = () => {
  const [moduleData, setModuleData] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { test_modules, view_recent_report, last_tested, total_tests } =
    pageLocale("testModule");

  const { accessToken, providerId, adminId, clientId } = getParams();
  useEffect(() => {
    // const storedTest = JSON.parse(sessionStorage.getItem("testMModule"));
    // if (storedTest) {
    //   setModuleData(storedTest);
    //   dispatch(setAPILoader(false));
    // } else {
    dispatch(setAPILoader(true));
    getTestModule(userInfoFetch()?.id, userInfoFetch()?.seniorId)
      .then((res) => {
        //locomotive hide
        const filterModuleData = res?.data?.data.filter((a) => {
          return a.moduleId !== 3;
        });
        setModuleData(filterModuleData);
        sessionStorage.setItem(
          "testMModule",
          JSON.stringify(filterModuleData),
          dispatch(setAPILoader(false)),
        );
      })
      .catch(() => {
        dispatch(setAPILoader(false));
      });
    // }
  }, []);

  const testDetailsModule = (id, status, value) => {
    if (status === true) {
      if (id === 1) {
        sessionStorage.setItem("romStatus", "noenter");
        navigate(TUG_SIDE_INFO + `${searchParams}`);
      }
      if (id === 2) {
        sessionStorage.setItem("romStatus", "noenter");
        navigate(GAIT_AND_BALANCE_INFO + `${searchParams}`);
      }
      if (id === 3) {
        sessionStorage.setItem("romStatus", "noenter");
        navigate(LOCOMOTIVE_INFO + `${searchParams}`);
      }
      if (id === 4) {
        sessionStorage.setItem("romStatus", "noenter");
        navigate(TUG_FRONT_INFO + `${searchParams}`);
      }
      if (id === 5) {
        sessionStorage.setItem("romStatus", "enter");
        navigate(ROM_DETAILS + `${searchParams}`);
      }
      sessionStorage.setItem("testDescription", JSON.stringify(value));
    }
  };

  const viewRecentReportHandler = (url, e) => {
    e.stopPropagation();
    window.location.href = url;
  };
  return (
    <UserDetailsHeader>
      <div className="test-module-block">
        <Typography className="title">{test_modules}</Typography>
        <div className="test-module-wrapper">
          {moduleData?.map((item, index) => {
            return (
              <Paper
                elevation={3}
                className={`test-module-box-wrapper ${item?.isOperationAllowed && "cursorShow"}`}
                key={index}
                onClick={() =>
                  testDetailsModule(
                    item?.moduleId,
                    item?.isOperationAllowed,
                    item,
                  )
                }
              >
                <div className="test-module-box">
                  <div className="item">
                    <div className="item-name-and-status">
                      <Typography
                        className={`title ${item?.isOperationAllowed ? "showColors" : "blured"}`}
                      >
                        {item?.moduleName}
                      </Typography>
                      <div className="icons-block">
                        {item?.isOperationAllowed ? (
                          <img
                            src={frontarrowIcon}
                            alt="arrow"
                            className="info-btn"
                          />
                        ) : (
                          <img
                            src={lockedIcon}
                            alt="arrow"
                            className="locked"
                          />
                        )}
                      </div>
                    </div>
                    <div className="module-info-wrap">
                      <img
                        src={item?.iconURL}
                        alt="module-img"
                        className="module-img"
                      />
                      <Typography
                        className={`module-description ${item?.isOperationAllowed ? "showColors" : "blured"}`}
                      >
                        {item?.description}
                      </Typography>
                    </div>
                    {item?.lastTestTaken && (
                      <div className="recent-test-info-wrap">
                        <div className="item">
                          <Typography className="test-title">
                            {last_tested}
                          </Typography>
                          <Typography className="info">
                            {dateFormatHanlder(item?.lastTestTaken)}
                          </Typography>
                        </div>
                        <div className="item-one">
                          <Typography className="test-title">
                            {total_tests}
                          </Typography>
                          <Typography className="info">
                            {item?.totalTest}
                          </Typography>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {item?.isReportAvailable && (
                  <div className="view-report-btn-wrapper">
                    <button
                      className="btn"
                      onClick={(e) =>
                        viewRecentReportHandler(
                          `${item?.reportURL}&isWebsite=true&accessToken=${accessToken}&providerId=${providerId}&adminId=${adminId}&clientId=${clientId}`,
                          e,
                        )
                      }
                    >
                      {view_recent_report}
                    </button>
                  </div>
                )}
              </Paper>
            );
          })}
        </div>
      </div>
    </UserDetailsHeader>
  );
};

export default TestModule;
